import {
  GET_MIXTUREORDER_REQUEST,
  GET_MIXTUREORDER_ERROR,
  GET_MIXTUREORDER_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import context from "../common/getEntity"
import RESOURCES from '../../api/resources';

const initialState = {};
export default (selectQuery, expandQuery, filterQuery) => (state = initialState, action) => {

  context.init(context);

  context.GET_ENTITY_REQUEST = GET_MIXTUREORDER_REQUEST;
  context.GET_ENTITY_ERROR = GET_MIXTUREORDER_ERROR;
  context.GET_ENTITY_SUCCESS = GET_MIXTUREORDER_SUCCESS;
  context.TOKEN_EXPIRED = TOKEN_EXPIRED;

  context.entityName = "mixtureOrder";
  context.entityLocation = RESOURCES.MixtureOrders;
  context.selectQuery = "ID,OrderNumber,Description,IsDeleted";
  context.expandQuery = "MixingPlant";
  context.orderByQuery = "OrderNumber, ID";

  if (selectQuery !== undefined && selectQuery !== null)
    context.selectQuery = selectQuery;

  if (expandQuery !== undefined && expandQuery !== null)
    context.expandQuery = expandQuery;

  if (filterQuery !== undefined && filterQuery !== null)
    context.filterQuery = filterQuery;

  return context.execute(context)()(state, action);
};